export const CHROME_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/fastlex/ibehegbfehkibapmnfannchicclcpial";

export const CONTACT_HASH = "/#contact";
